export default [ 
  {
    path: 'rewards',
    component: () => import('@/views/Rewards'),
    children: [
      {
        name: 'rewards',
        path: 'balance',
        component: () => import('@/views/Rewards/tabs/Balance'),
      },
      {
        name: 'rewards/wallet',
        path: 'wallet',
        component: () => import('@/views/Rewards/tabs/Wallet'),
      },
      {
        name: 'rewards/topusers',
        path: 'top_users',
        component: () => import('@/views/Rewards/tabs/TopUsers'),
      },
      {
        name: 'rewards/earnmore',
        path: 'earnmore',
        component: () => import('@/views/Rewards/tabs/EarnMore'),
      },
    ]
  },
  {
    name: 'redeem',
    path: 'rewards/redeem',
    component: () => import('@/views/Rewards/Redeem'),
  },
  {
    name: 'redeem/card',
    path: 'rewards/redeem/card/:brand_key',
    component: () => import('@/views/Rewards/Redeem/Card'),
    props: true,
  },
  {
    name: 'reward',
    path: 'reward/:redemption_id',
    component: () => import('@/views/Rewards/Reward'),
    props: true,
  },
]
